import type { SchemaOf } from '../helpers';
import { Joi, makeAllOptional, objectSchemaOf } from '../helpers';

export const pubSubMessageSchemaMap: SchemaOf<IPubSubMessageShape<{}>> = {
  traceId: Joi.string().required(),
  channel: Joi.string().required(),
  messageId: Joi.string().required(),
  senderId: Joi.string().required(),
  timestamp: Joi.number().required(),
  type: Joi.string().required(),
  payload: Joi.alternatives(Joi.object(), Joi.array()),
};

export const partialPubSubMessageSchemaMap = makeAllOptional(
  pubSubMessageSchemaMap
);

export const pubSubMessageSchema = objectSchemaOf<IPubSubMessageShape<{}>>(
  pubSubMessageSchemaMap
);

export type IPubSubMessageShape<ActionShape> = {
  traceId: string;
  channel: string;
  messageId: string;
  senderId: string;
  timestamp: number;
  type: string;
  payload?: unknown;
} & ActionShape;

const isObjectSchema = (schema: Joi.AnySchema): schema is Joi.ObjectSchema => {
  return schema.type === 'object';
};

export function strictMessageSchema<T>(
  input: Joi.SchemaMap<T> | Joi.ObjectSchema<T>
): Joi.ObjectSchema<T> {
  const schema = Joi.compile(input);
  if (!isObjectSchema(schema)) {
    throw new TypeError('Expected object schema type');
  }

  const { type, payload, ...map } = pubSubMessageSchemaMap;

  return Joi.object(map).concat(schema) as Joi.ObjectSchema<
    IPubSubMessageShape<T>
  >;
}

export function partialMessageSchema<T>(
  input: Joi.SchemaMap<T> | Joi.ObjectSchema<T>
): Joi.ObjectSchema<T> {
  const schema = Joi.compile(input);
  if (!isObjectSchema(schema)) {
    throw new TypeError('Expected object schema type');
  }

  const { type, payload, ...map } = partialPubSubMessageSchemaMap;

  return Joi.object(map).concat(schema) as Joi.ObjectSchema<
    IPubSubMessageShape<T>
  >;
}
